import 'isomorphic-fetch';
import * as $$BASE from '../actions/baseAction';
import * as USER_TYPE from '../constants/types/userTypes';
import $CACHE from '../helpers/cache';
import { DOMAIN } from '../constants/config';
import { Hex_MD5 } from '../helpers/unit';

window._FETCHING = window._FETCHING || {};

function checkStatus(response) {
  if (response.status === 200) {
    return response;
  }
  var error = new Error(response.status);
  error.response = response;
  throw error;
}

// 生成请求 KEY
function uniqueFetch(url, method) {
  return Hex_MD5(url + method);
}

function request({ url, method, data }, successCallback, errorCallback) {
  fetch(DOMAIN + url + '&client=m', {
    method: method || 'GET',
    credentials: 'include',
    headers: {
      Authorization: 'bearer ' + window.AUTH_TOKEN
    },
    body: data ? JSON.stringify(data) : undefined
  })
  .then(checkStatus)
  .then(response => response.json())
  .then(successCallback)
  .catch(errorCallback);
}

export default store => next => action => {
  if (!action.dbpayload || !action.dbpayload.url) {
    return next(action);
  }

  const { url, method, data, loading, cache } = action.dbpayload;
  const { callback, pick } = action;

  // LS CACHE
  if (cache) {
    const _cache_ = $CACHE.get(cache.key);
    if (_cache_) {
      if (callback && _.isFunction(callback)) {
        callback({res: _cache_.data, action});
      }
      return next({ ...action, result: _cache_.data });
    }
  }

  // 唯一请求
  const requestUniqueKey = uniqueFetch(url, method);

  if (window._FETCHING[requestUniqueKey]) {
    return;
  } else {
    window._FETCHING[requestUniqueKey] = true;
  }

  if (loading) {
    if (_.isObject(loading)) {
      store.dispatch($$BASE.openLoading(loading.text));
    } else {
      store.dispatch($$BASE.openLoading());
    }
  }

  return request(
    { url, method, data },
    res => {

      // 关闭重复请求限制
      delete window._FETCHING[requestUniqueKey];
      
      if (loading) {
        store.dispatch($$BASE.closeLoading());
      }
      
      // 业务错误
      if (res.sMsg && res.sMsg.indexOf('重新登录') > -1) {
        if (!_.includes(window.location.href, '#/login')) {
          next($$BASE.openAlert('登录超时，请重新登录'));
          next($$BASE.showUI(0.3));
          return next({ type: USER_TYPE.LOGOUT });
        }
      }

      let pickBefore = [], pickAfter = [];
      _.each(pick, item => {
        pickBefore.push(item.split('->')[0]);
        if(!item.split('->')[1]){
          pickAfter.push(item.split('->')[0]);
        }else{
          pickAfter.push(item.split('->')[1]);
        }
      })
      let cNameResult = _.pick(res, pickBefore);
      let cleanResult = {};
      _.each(pickAfter, (item, index) => {
        cleanResult[item] = cNameResult[pickBefore[index]];
      })
      if(res.pageinfo || res.pages){
        const pageInfo = res.pageinfo || res.pages;
        cleanResult.recordsCount = parseInt(_.split(pageInfo, ' ')[1]);
      }
      action.result = cleanResult;

       // 回调函数
      if (callback && _.isFunction(callback)) {
        callback({res: cleanResult, action});
      }

      // 缓存
      if (cache) {
        $CACHE.put(cache.key, cleanResult, cache.expires);
      }

      // DISPATCH TYPE
      return next({ ...action, result: cleanResult });
    },
    error => {
      window.setTimeout(function() {
        const requestUniqueKey = uniqueFetch(url, method);
        delete window._FETCHING[requestUniqueKey];
      }, 500);
      if (loading) {
        store.dispatch($$BASE.closeLoading());
      }
      if(error.message == 429){
        store.dispatch($$BASE.openToast('请求过于频繁，请稍后再试'))
      }
      if (process.env.NODE_ENV === 'production') {
        console.log(error);
      }
    }
  );
};
